module.exports = __webpack_public_path__ + "static/media/back10.d42730c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back10.jpg
// module id = 275
// module chunks = 0